import { useContext } from 'react';
import ChallengePortfolioContext from '../../../ChallengePortfolioContext';
import useApi from '@/lib/api/useApi';
import { type RowWithoutRelations } from '@/lib/types';

const useCreateRow = (): ((name: string) => Promise<RowWithoutRelations>) => {
  const api = useApi();

  const [, setChallengePortfolio] = useContext(ChallengePortfolioContext);

  const createRow = async (name: string): Promise<RowWithoutRelations> => {
    const row = await api.post<RowWithoutRelations>(
      'challenge-portfolio/rows',
      {
        name,
      },
    );

    setChallengePortfolio(challengePortfolio => {
      challengePortfolio.rows[row.id] = {
        ...row,
        challenges: [],
      };
    });

    return row;
  };

  return createRow;
};

export default useCreateRow;
